import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["attachRight"];
import React from 'react';
import { List } from './List';
import { StyledMenu } from './Menu.styled';
export function Menu(_ref) {
  var attachRight = _ref.attachRight,
    listProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledMenu, {
    attachRight: attachRight
  }, /*#__PURE__*/React.createElement(List, listProps));
}